module.exports = __webpack_public_path__ + "static/img/recruit_2024_btn_ttl.86cd211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/recruit_2024_btn_ttl.png
// module id = eN+o
// module chunks = 0